module.exports = __webpack_public_path__ + "static/media/no_button.bc38ec55.svg";